import { Skeleton } from '@mui/material';
import { Text } from '@src/shared/ui';
import React from 'react';

type RecommendedProps = {
  show?: boolean;
  sm?: boolean;
  loading?: boolean;
};

export const Recommended: React.FC<RecommendedProps> = ({
  sm,
  show,
  loading,
}) => {
  const className = `
          absolute
          -mt-[10px]
          ml-6
          rounded-[10px]
          text-[12px]
          leading-4

          sm:hidden
        `;

  const classNameSm = `
          hidden
          rounded-[12px]
          text-[14px]
          leading-5
          ml-6

          sm:block
          sm:mt-6
          sm:mr-6
        `;

  const customClass = !sm && !loading ? className : classNameSm;

  if (loading && sm) {
    return (
      <Skeleton
        variant='rounded'
        width={114}
        height={24}
        className={customClass}
      />
    );
  } else if (show && !loading) {
    return (
      <Text
        color='white'
        className={`
          ${customClass}
          w-min
          h-min
          font-semibold
          bg-radiant-blue-30
          py-[2px]
          px-2
        `}
      >
        Recomendado
      </Text>
    );
  } else {
    return <></>;
  }
};
